import { richTextComponentMapping } from '@repo/roche-xx-shared';
import { storyblokInit } from '@storyblok/react';

// bridge loaded manually by EditorService to avoid race. only purpose here: register richtext component map.
storyblokInit({ bridge: false, components: richTextComponentMapping });
